import React from 'react';
import styled from 'styled-components';
import theme from '@theme';
import renderSkeletons from './renderSkeltons';

const SiteInformationsSkeleton: React.FC = () => {
  const skeletonStyle = {
    baseColor: theme.palette.grey[200],
    borderRadius: 5,
    className: 'mx-2'
  };

  const skeletonRows = [
    [{ width: 250, height: 8 }],
    [
      { width: 138, height: 8 },
      { width: 138, height: 8 },
      { width: 138, height: 8 }
    ],
    [{ width: 138, height: 8 }]
  ];

  return (
    <SkeletonWrapper>
      {renderSkeletons(skeletonRows[0].map((skeleton) => ({ ...skeleton, ...skeletonStyle })))}
      <GridWrapper>
        {renderSkeletons(skeletonRows[1].map((skeleton) => ({ ...skeleton, ...skeletonStyle })))}
      </GridWrapper>
      <GridWrapper>
        {renderSkeletons(skeletonRows[2].map((skeleton) => ({ ...skeleton, ...skeletonStyle })))}
      </GridWrapper>
    </SkeletonWrapper>
  );
};

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
`;

const SkeletonWrapper = styled.div`
  br {
    display: none;
  }
`;

export default SiteInformationsSkeleton;
